import { createFileRoute } from '@tanstack/react-router'

import { BOILER_ROOM_DOMAIN } from '@/components/module-synoptic/module-synoptic-domain'
import { manageRouteOptions } from '@/components/module-synoptic/module-synoptic-route-options'

// Gestion des synoptiques de chaufferie. Garde OuiSense et préchargement sont communs aux catégories
// de synoptiques à modules (cf. module-synoptic-route-options).
export const Route = createFileRoute('/_dashboard/site/$id/boiler-room/technical/manage/')(manageRouteOptions(BOILER_ROOM_DOMAIN))
